import React from 'react'
import Login from '../components/login/login'
import { useTranslation } from "react-i18next"

export default function LoginPage() {
    const { t } = useTranslation()

    return (
        <>
            <Login t={t} />
        </>
    )
}